import {mParticleLogPageView} from '@treatwell/ui';
import {fetchChannel} from '../../../api/rainbow';

export function trackRegisterPageView(isWebMobile: boolean) {
  return fetchChannel()
    .then((channel) => {
      return mParticleLogPageView('signup', {
        country: channel.country.countryCode,
        platform: 'web',
        is_web_mobile: isWebMobile,
      });
    })
    .catch(() => {});
}
